module.exports = __webpack_public_path__ + "assets/img/img_error.17d6a213.svg";